<template>
  <div class="title-top clearfix">
    <div class="title-li clearfix title-anim fl" style="width: 46%">
      <div class="fr">
        <slot> </slot>
      </div>
      <!-- <img src="" alt=""> 
          <div class="fr" style="width:48px;height:52px;background:red;"></div> -->
    </div>
    <div class="title-li clearfix fl" style="padding-left: 8px; width: 54%">
      <div class="fl">
        <div class="title-text">{{ title }}</div>
        <div class="title-text2">{{ enTitle }}</div>
      </div>
    </div>
  </div>
</template> 

<script>
export default {
  name: "titletop",
  props: {
    title: {
      type: String
    },
    enTitle: {
      type: String
    }
  },
  data () {
    return {

    }
  },
};
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>



// WEBPACK FOOTER //
// src/components/titletop/index.vue